import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "./TopCategories.css";
import { Link } from "react-router-dom";

// استيراد الداتا من JSON
import Categories from "../../data/Categories.json";

function TopCategories() {
  return (
    <section className="top-Categories container-fluid gray-bg px-md-5 py-5">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="section-title">Top Categories</h2>
        <Link to="/categories" className="btn btn-outline-primary">
          View All
        </Link>
      </div>

      {/* Slider */}
      <Swiper
        modules={[Autoplay]}
        spaceBetween={30}
        slidesPerView={4}
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        speed={800}
        breakpoints={{
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          992: { slidesPerView: 4 },
          1200: { slidesPerView: 5 },
        }}
      >
        {Categories.map((cat) => (
          <SwiperSlide key={cat.id} className="text-center py-2">
            <Link to={`/categories/${cat.id}`}>
              <div className="product-circle mx-auto mb-2">
                <img src={cat.image} alt={cat.name} className="img-fluid" />
              </div>
              <p className="product-name">{cat.name}</p>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default TopCategories;
